// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__2INpi","cards":"ClientCreditCards_cards__2b5O-","empty":"ClientCreditCards_empty__1FUFY"};